export const containerSx = {
    background: "#FFFFFF",
    border: "1px solid #E0DEDD",
    borderRadius: "12px",
    boxShadow: "0px 2px 8px 0px rgba(42, 43, 39, 0.04)",
    padding: "24px",
    display: "flex",
    flexDirection: "column",
    gap: "24px",
} as const;

export const headerIconBoxSx = {
    width: 40,
    height: 40,
    borderRadius: "8px",
    background: "#FFF7E4",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
} as const;

export const gridSx = {
    display: "grid",
    gridTemplateColumns: { xs: "1fr", md: "repeat(2, minmax(0, 1fr))" },
    alignItems: "start",
    justifyItems: "stretch",
    gap: "24px",
} as const;

export const cardSx = {
    background: "#FEFCFB",
    border: "1px solid #E0DEDD",
    borderRadius: "12px",
    padding: "16px",
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    gap: "12px",
    height: "100%",
    minWidth: 0,
} as const;

export const actionButtonSx = {
    width: 40,
    height: 40,
    borderRadius: "8px",
    background: "linear-gradient(180deg, rgba(255, 255, 255, 1) 0%, rgba(246, 245, 243, 1) 100%)",
    border: "1px solid #E7E6E4",
} as const;
